class WorkFlowConditions {
  constructor(props) {
    const {
      display,
      name,
      type
    } = props;

    this.id = name;
    this.display_value = display;
    this.type = type;
  }
}

export default WorkFlowConditions;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/models/WorkFlowConditions.js